import $ from 'jquery';

if ($.ui) {
  /** BugFix : Jquery UI Dialog & CK-Editor Bugfix when opening a CK-Toolar Dialog
     All dialog inputs are locked / disabled */
  $.widget('ui.dialog', $.ui.dialog, {
    /*! jQuery UI - v1.11.4 - 2015-06-05
     *  http://bugs.jqueryui.com/ticket/9087#comment:27 - bugfix
     *  http://bugs.jqueryui.com/ticket/4727#comment:23 - bugfix
     *  allowInteraction fix to accommodate windowed editors
     */
    _allowInteraction: function (event) {
      if (this._super(event)) {
        return true;
      }

      // address interaction issues with general iframes with the dialog
      if (event.target.ownerDocument && event.target.ownerDocument != this.document[0]) {
        return true;
      }

      // address interaction issues with dialog window
      if ($(event.target).closest('.cke_dialog').length) {
        return true;
      }

      // address interaction issues with iframe based drop downs in IE
      if ($(event.target).closest('.cke').length) {
        return true;
      }
    },
  });
}
